module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="coming-soon">\n    <div class="text-block">\n        <h5>LEAGUE FINALS FIXTURES WILL BE AVAILABLE AT THE CONCLUSION OF THE FANTASY HOME AND AWAY SEASON</h5>\n    </div>\n</div>\n';
}
return __p;
};
